import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "antd/dist/antd.css";
import { Button as AntButton, message } from "antd";
import classes from "./templateBuilder.module.css";
import Table from "./Table/Table";
import Collapsable from "../collapsable";
import { Tabs } from "antd";
import responseLoader from "../Responses/responseLoader";
import axios from "../../../Axios";
import { useSelector } from "react-redux";
import Button from "../../Auth/button";
import Layover from "../responseSelect";
const uuid = require("uuid");

const { TabPane } = Tabs;

const initialPanes = [
  {
    title: "",
    content: [],
    key: uuid(),
  },
];

const initialState = {
  blocked: false,
  editable: true,
};

const TemplateBuilder = () => {
  const history = useHistory();
  const responseList = useSelector((state) => state.responses);
  const [panes, setPanes] = useState([...initialPanes]);
  const [activeKey, setActiveKey] = useState(initialPanes[0].key);
  const [templateTitle, setTemplateTitle] = useState(null);
  const [layoverShown, setLayoverShown] = useState([false, -1, -1]);
  let responses = null;
  const [saveLoading, setSaveLoading] = useState(false);

  const [state, setState] = useState({ ...initialState });

  useEffect(() => {
    const fetchFunc = async () => {
      const urlParams = new URLSearchParams(history.location.search);
      const id = urlParams.get("id");

      if (id) {
        const template = await axios.post("/templates/fetch", {
          fetchType: 0,
          where: { _id: id },
          fetchItems: [],
        });
        const { payload } = template.data;
        const payloadPanes = payload[0].panes.map((pane) => {
          return { ...pane, ["key"]: pane._id };
        });
        console.log(payload);
        setTemplateTitle(payload[0].title);
        setPanes(payloadPanes);
        setActiveKey(payload[0].panes[0] ? payload[0].panes[0]._id : null);
      }
    };
    fetchFunc();
  }, []);
  const tempResponses = responseLoader(responseList);
  responses = { ...tempResponses };
  const templateTitleChange = (e) => setTemplateTitle(e.target.value);
  const layoverSwitch = (indOne, indTwo) => {
    if (!layoverShown[0]) {
      setLayoverShown([true, indOne, indTwo]);
      return 0;
    }

    setLayoverShown([false, -1, -1]);
  };

  const onPaneChange = (newActiveKey) => {
    let targetIndex = null;
    if (newActiveKey !== activeKey) {
      panes.forEach((pane, index) => {
        if (pane.key === activeKey) targetIndex = index;
      });
      if (targetIndex !== null) {
        const input = document.getElementsByClassName(classes.colr)[
          targetIndex
        ];
        input.setAttribute("disabled", "true");
      }
    }
    setActiveKey(newActiveKey);
  };
  const optionChangeHandler = (resId) => {
    const tabIndex = layoverShown[1];
    const queIndex = layoverShown[2];
    const tempPanes = [...panes];
    const tempPane = { ...tempPanes[tabIndex] };

    const tempContent = [...tempPane.content];
    const tempQues = { ...tempContent[queIndex] };

    tempQues.answer = resId;

    tempContent[queIndex] = tempQues;
    tempPane.content = tempContent;
    tempPanes[tabIndex] = tempPane;
    setPanes(tempPanes);
  };
  const addQuestionHandler = (index) => {
    const tempPanes = [...panes];
    const pane = { ...tempPanes[index] };
    const paneContent = [...pane.content];
    const question = { question: "", answer: "", mandatory: [] };
    paneContent.push(question);
    pane.content = paneContent;
    tempPanes[index] = pane;

    setPanes(tempPanes);
  };

  const mandatoryHandle = (check, data) => {
    const tempPanes = [...panes];
    const tempPane = { ...tempPanes[layoverShown[1]] };

    const tempContent = [...tempPane.content];
    const tempQuestion = { ...tempContent[layoverShown[2]] };

    const tempMandatory = new Set(tempQuestion.mandatory);

    if (check) tempMandatory.add(data);
    else tempMandatory.delete(data);

    tempQuestion.mandatory = [...Array.from(tempMandatory)];
    tempContent[layoverShown[2]] = tempQuestion;

    tempPane.content = tempContent;
    tempPanes[layoverShown[1]] = tempPane;
    setPanes(tempPanes);
  };

  const add = () => {
    const id = uuid();
    const newPanes = [...panes, { title: "", content: [], key: id }];

    setPanes(() => [...newPanes]);
    setActiveKey(id);
  };

  const remove = (targetKey) => {
    let newActiveKey = activeKey;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const modifiedPanes = panes.filter((pane) => pane.key !== targetKey);
    if (modifiedPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = panes[lastIndex].key;
      } else {
        newActiveKey = null;
      }
    }

    setActiveKey(() => newActiveKey);
    setPanes(() => modifiedPanes);
  };

  const onEdit = (targetKey, action) => {
    if (action === "add") add(targetKey);
    else if (action === "remove") remove(targetKey);
  };
  const onTabTitleChange = (e, pane, index) => {
    const updatedPanes = [...panes];
    const updatedElement = { ...updatedPanes[index] };
    updatedElement.title = e.target.value;
    updatedPanes[index] = updatedElement;
    setPanes(updatedPanes);
  };

  const questionChangeHandler = (e, indOne, indTwo) => {
    const value = e;
    const tempPanes = [...panes];

    const tempPane = { ...tempPanes[indOne] };
    const tempContent = [...tempPane.content];

    const tempQues = { ...tempContent[indTwo] };

    tempQues.question = value;
    tempContent[indTwo] = tempQues;

    tempPane.content = tempContent;

    tempPanes[indOne] = tempPane;

    setPanes(tempPanes);
  };
  const headings = {
    "s no.": "s no.",
    "audit question": "question",
    response: "answer",
    kebab: "kebab",
  };
  const onEditClick = (index) => {
    const input = document.getElementsByClassName(classes.colr)[index];
    input.toggleAttribute("disabled");
  };

  const saveHandler = async () => {
    setSaveLoading(true);

    const save = await axios.post("/templates/create", {
      title: templateTitle,
      panes: [...panes],
      ...state,
    });
    console.log(save);
    if (save.data.success) {
      message.success("Template created successfully");
      history.push("/templates");
    } else {
      message.error(save.data.message);
    }

    setSaveLoading(false);
  };

  const removeQuesHandler = (indOne, indTwo) => {
    const tempPanes = [...panes];
    const tempPane = { ...tempPanes[indOne] };

    const tempContent = [...tempPane.content];
    tempContent.splice(indTwo, 1);

    tempPane.content = tempContent;
    tempPanes[indOne] = tempPane;

    setLayoverShown([false, -1, -1]);
    setPanes(tempPanes);
  };

  const headerChecks = {
    blocked: "Blocked",
    editable: "Editable",
  };

  const checkChangeHandler = (e) => {
    const { name, checked } = e.target;
    setState({ ...state, [name]: checked });
  };

  const checkElements = Object.keys(headerChecks).map((check) => {
    return (
      <div className={classes.checkHolder}>
        <input
          type="checkbox"
          onChange={checkChangeHandler}
          checked={state[check]}
          name={check}
        ></input>
        <span>{headerChecks[check]}</span>
      </div>
    );
  });
  return (
    <div>
      <div className={classes.builderHead}>
        <div className={classes.mainHeader}>
          <h2>
            <span>
              <input
                placeholder="Template Name"
                value={templateTitle}
                onChange={templateTitleChange}
                className={[classes.colrHead].join(" ")}
              />
            </span>
          </h2>

          {checkElements}
        </div>
        <div className={classes.controls}>
          <AntButton
            onClick={saveHandler}
            className={[classes.controlBtn, classes.saveBtn].join(" ")}
            loading={saveLoading}
          >
            Save
          </AntButton>
        </div>
      </div>
      <hr />
      <Tabs
        type="editable-card"
        onChange={onPaneChange}
        activeKey={activeKey}
        onEdit={onEdit}
      >
        {panes.map((pane, index) => (
          <TabPane
            tab={
              <div>
                <input
                  className={classes.colr}
                  placeholder="New Section"
                  disabled
                  type="text"
                  value={pane.title}
                  onChange={(e) => onTabTitleChange(e, pane, index)}
                />
                <i
                  onClick={() => onEditClick(index)}
                  class={[classes.pencil, "fas fa-pencil-alt"].join(" ")}
                ></i>
              </div>
            }
            key={pane.key}
            closable={pane.closable}
            className={classes.tab}
          >
            <div className={classes.paneContent}>
              {
                <Collapsable
                  heading={pane.title ? pane.title : "New Section"}
                  extraClass={classes.collapsable}
                  collapseClass={classes.collapse}
                  inputs={
                    <>
                      <Table
                        datas={pane.content}
                        layoverShown={layoverShown}
                        layoverSwitch={(ind) => layoverSwitch(index, ind)}
                        headings={headings}
                        responses={responses}
                        onQuesChange={(e, indTwo) =>
                          questionChangeHandler(e, index, indTwo)
                        }
                        editable={true}
                      ></Table>
                      <Button
                        onClick={() => {
                          addQuestionHandler(index);
                        }}
                        extraClass={classes.addBtn}
                      >
                        {" "}
                        Add Question{" "}
                      </Button>
                    </>
                  }
                />
              }
            </div>
          </TabPane>
        ))}
      </Tabs>
      <Layover
        selected={
          layoverShown[0] && panes[layoverShown[1]].content[layoverShown[2]]
            ? panes[layoverShown[1]].content[layoverShown[2]].answer
            : null
        }
        checked={
          layoverShown[0] && panes[layoverShown[1]].content[layoverShown[2]]
            ? panes[layoverShown[1]].content[layoverShown[2]].mandatory
            : []
        }
        optionChangeHandler={(e) => optionChangeHandler(e.target.value)}
        visible={layoverShown[0]}
        deleteHandler={() =>
          removeQuesHandler(layoverShown[1], layoverShown[2])
        }
        mandatoryHandle={mandatoryHandle}
        layoverSwitch={layoverSwitch}
        responseList={responseList}
      ></Layover>
    </div>
  );
};

export default TemplateBuilder;
